import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initSentry } from "./utils/logger";

// Sentryの初期化（DSNが設定されている場合のみ）
if (process.env.REACT_APP_SENTRY_DSN) {
  initSentry(process.env.REACT_APP_SENTRY_DSN);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
